/**
 * Observe Fontface
 *
 * @since 1.0.0
 */
import FontFaceObserver from "fontfaceobserver";
export default () => {
  const font = new FontFaceObserver('Poppins'); // Add font here
  font.load().then(() => {
    if (!document.documentElement.classList.contains("fonts-loaded")) {
      document.documentElement.classList.add("fonts-loaded");
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modules/ObserveFontFace.js
